import { createMuiTheme } from '@material-ui/core';

// A custom theme for this app
const theme = createMuiTheme({
    palette: {
        primary: {
            main: '#EC2024',
        },
        secondary: {
            main: '#9E1C1E',
        },
        background: {
            default: '#fff',
        },
    },
});

export default theme;
